// extracted by mini-css-extract-plugin
module.exports = {"Autopay":"Autopay_Autopay__eat4M","enabled":"Autopay_enabled__fu1-J","toggle":"Autopay_toggle__3bw-1","on":"Autopay_on__2T12h","off":"Autopay_off__v8sFN"};